import React from "react";
import { BRAND, STATUS_COLORS } from "../../../utils/chartTheme";
import { formatCount } from "../../../utils/numberFormat";

const ActivityTypeCard = ({ title, count, variant = "default" }) => {
  const borderColors = {
    default: "#ededed",
    records: BRAND.teal,
    completed: STATUS_COLORS.completed,
    boqs: BRAND.teal,
    monitored: BRAND.teal,
    coverage: BRAND.teal,
    frequency: BRAND.teal,
  };

  const borderColor = borderColors[variant] || borderColors.default;

  return (
    <div>
      <div
        className="bg-[#f7f7f7] text-white h-28 p-2.5 rounded-3xl border-2 hover:border-teal-300 transition-all duration-300 hover:shadow-md"
        style={{ borderColor }}
      >
        <h3 className="text-2xl text-center mt-4 mb-0 text-[#3A3A3A] p-0 font-bold text-balance">
          {count !== undefined && count !== null ? count : 0}
        </h3>
        <h6 className="text-xs text-center p-0 m-0 text-[#787878] font-semibold">
          {title}
        </h6>
      </div>
    </div>
  );
};

const OverallStatusWidget = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="text-center">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase mb-4 text-balance">
          Monitoring Summary
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="bg-gray-100 rounded-3xl h-28 animate-pulse"
            ></div>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-3 mt-3">
          {[5, 6].map((i) => (
            <div
              key={i}
              className="bg-gray-100 rounded-lg h-20 animate-pulse"
            ></div>
          ))}
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="text-center">
        <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase mb-4 text-balance">
          Monitoring Summary
        </h3>
        <div className="bg-gray-50 rounded-lg p-6">
          <p className="text-gray-500">No monitoring data available</p>
        </div>
      </div>
    );
  }
  const formatPercentage = (value) => {
    if (!value && value !== 0) return "0%";
    const num = parseFloat(value);
    if (isNaN(num)) return "0%";
    return `${num.toFixed(1)}%`;
  };
  const getMonitoringCounts = () => {
    return {
      totalMonitoringRecords: data.totalMonitoringRecords || 0,
      completedFeatures: data.completedFeatures || 0,
      totalBOQs: data.totalBOQs || 0,
      monitoredFeaturesCount: data.monitoredFeaturesCount || 0,
      monitoringCoverageRate: data.monitoringCoverageRate || 0,
      averageMonitoringFrequency: data.averageMonitoringFrequency || 0,
    };
  };

  const counts = getMonitoringCounts();

  return (
    <div className="text-center">
      {/* Title */}
      {/* <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase mb-4 text-balance">
        Monitoring Summary
      </h3> */}
      <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase mb-4 text-balance">
        Monitoring Summary
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <ActivityTypeCard
          title="Monitoring Records"
          count={formatCount(counts.totalMonitoringRecords)}
          variant="records"
        />
        <ActivityTypeCard
          title="Completed Features"
          count={formatCount(counts.completedFeatures)}
          variant="completed"
        />
        <ActivityTypeCard
          title="Total BOQs"
          count={formatCount(counts.totalBOQs)}
          variant="boqs"
        />
        <ActivityTypeCard
          title="Monitored Features"
          count={formatCount(counts.monitoredFeaturesCount)}
          variant="monitored"
        />
      </div>
      <div className="grid grid-cols-2 gap-3 mt-3">
        {/* <div className="bg-[#f7f7f7] rounded-lg border-2 border-[#10B981] hover:border-teal-300 transition-all duration-300 hover:shadow-md p-4">
          <h6 className="text-xs text-center p-0 m-0 text-[#787878] font-semibold">
            Coverage Rate
          </h6>
          <h3 className="text-2xl text-center mt-2 mb-0 text-[#3A3A3A] p-0 font-bold text-balance">
            {formatPercentage(counts.monitoringCoverageRate)}
          </h3>
          <p className="text-xs text-center text-gray-500 mt-1">
            of all BOQs monitored
          </p>
        </div> */}

        {/* <div className="bg-[#f7f7f7] rounded-lg border-2 border-[#3B82F6] hover:border-teal-300 transition-all duration-300 hover:shadow-md p-4">
          <h6 className="text-xs text-center p-0 m-0 text-[#787878] font-semibold">
            Avg Monitoring Frequency
          </h6>
          <h3 className="text-2xl text-center mt-2 mb-0 text-[#3A3A3A] p-0 font-bold text-balance">
            {counts.averageMonitoringFrequency}
          </h3>
          <p className="text-xs text-center text-gray-500 mt-1">
            times per feature
          </p>
        </div> */}
      </div>
      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* <div className="text-left">
          <p className="text-sm text-gray-600">
            <span className="font-semibold">Coverage Rate:</span>{" "}
            {formatPercentage(counts.monitoringCoverageRate)} of all BOQs have
            been monitored
          </p>
        </div> */}
        {/* <div className="text-left md:text-right">
          <p className="text-sm text-gray-600">
            <span className="font-semibold">Avg Frequency:</span> Each feature
            monitored {counts.averageMonitoringFrequency} times on average
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default OverallStatusWidget;
